import React, { useState, useEffect } from 'react';
import { signIn, signOut, confirmSignIn, fetchAuthSession } from 'aws-amplify/auth';
import { Form, Button, Spinner } from 'react-bootstrap';
import { useNavigate, useLocation, location } from "react-router-dom";
import config from 'react-global-configuration';
import axios from 'axios';
import toastr from "toastr";

function Login({params}) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  
  useEffect(() => {
    document.body.className = 'empty';
    getCurrentUser();
  }, []);
  
  const getCurrentUser = async (e) => {
    const { accessToken, idToken } = (await fetchAuthSession()).tokens ?? {};
    if (accessToken) {
      gotoLandingPage();
    } else {
      document.body.className = 'login';
      await signOut();
      localStorage.clear();
    }
  }
  
  const gotoLandingPage = (e) => {
    navigate('/landing');
  }

  const gotoUpdatePassword = (e) => {
    navigate('/updatepassword', { state: email});
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (email === '' || password === '') {
        toastr.warning('Preencha todos os campos obrigatórios');
        setLoading(false);
        return;
      }
      const { isSignedIn, nextStep } = await signIn({ username: email, password: password });

      if (!isSignedIn && nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        await confirmSignIn({challengeResponse: password});
        gotoUpdatePassword();
      } else {
        try {
          await getSession();
        } catch (error) {
          setLoading(false);
          toastr.error(error);
          return;
        }
        gotoLandingPage();
      }
    } catch (error) {
      if (error.name === 'NotAuthorizedException') {
        toastr.error('Usuário ou senha incorretos', 'Erro na tentativa de login:');
      } else if (error.name === 'UserAlreadyAuthenticatedException') {
        try {
          await getSession();
          gotoLandingPage();
        } catch (error) {
          setLoading(false);
          let msg = '';
          if (error.name == 'AxiosError') {
            msg = error.message;
          } else {
            msg = error;
          }
          toastr.error(msg);
          return;
        }
      } else {
        toastr.error('Erro na tentativa de login');
      }
      console.error('Erro na tentativa de login:', error);
      setLoading(false);
    }
  };

  const getSession = async () => {
    const { accessToken, idToken } = (await fetchAuthSession()).tokens ?? {};
    const param = '&user_id=' + accessToken;
    const url = config.get('urlbase') + '/user/session?' + param;
    const headers = { 'x-api-key': config.get('apiKey') , 'Content-Type': 'application/json' };
    const userInfos = await axios.get(url, { headers });
    localStorage.setItem('userInfos', JSON.stringify(userInfos));
  }

  const getSignOut = async () => {
    await signOut();
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  return (
    <div className='panel-login'>
      <img src={process.env.PUBLIC_URL + '/static/imagens/logo.svg'} className='display--block margin--auto' alt='Logomarca' />
      <h1 className='title-login text-center'>Preencha os dados e faça o seu login</h1>
      <Form onSubmit={handleLogin}>
        <Form.Group controlId="formBasicEmail" className='group-input--big' style={{ marginTop: "35px" }}>
          <Form.Label>Email*:</Form.Label>
          <Form.Control type="email" value={email} onChange={handleEmailChange} className='input--big' />
        </Form.Group>

        <Form.Group controlId="formBasicPassword" className='group-input--big' style={{ marginTop: "35px", marginBottom: "50px" }}>
          <Form.Label>Senha*:</Form.Label>
          <Form.Control type="password" value={password} onChange={handlePasswordChange} className='input--big' />
        </Form.Group>

        <a href='/forgotpassword' className='margin--auto text-center display--block' style={{ marginBottom: "40px" }}>Esqueceu a senha?</a>

        {loading ?
          <div className="text-center">
            <Spinner animation="border" variant="success" />
          </div>
          :
          <Button variant="primary" type="submit" className='margin--auto display--block'>
            Entrar
          </Button>
        }
      </Form>
    </div>
  );
};

export default Login;


